import React, { Component } from 'react';
import { connect } from 'react-redux';
import { findPreactivation } from 'actions/preactivations';
import { getPreactivation } from 'reducers';

const injectPreactivation = (DecoratedComponent) => {
  class InjectPreactivation extends Component {
    componentDidMount() {
      this.props.preactivationId && this.fetchPreactivation();
    }
    componentDidUpdate(oldProps) {
      if (this.props.preactivationId !== oldProps.preactivationId) {
        this.fetchPreactivation();
      }
    }
    fetchPreactivation() {
      const { findPreactivation, preactivationId } = this.props;
      preactivationId && findPreactivation(preactivationId);
    }

    render() {
      const { children, findPreactivation, user, ...props } = this.props;
      return React.createElement(
        DecoratedComponent,
        { ...props, user },
        children,
      );
    }
  }

  const mapStateToProps = (state, { preactivationId, sub }) => {
    preactivationId = preactivationId || (sub && sub.preactivation);
    return {
      preactivation:
        preactivationId && getPreactivation(state, preactivationId),
      preactivationId,
    };
  };

  const mapDispatchToProps = {
    findPreactivation,
  };

  return connect(mapStateToProps, mapDispatchToProps)(InjectPreactivation);
};

export default injectPreactivation;
